class Utils {
  constructor() {
    if (Utils.instance) return Utils.instance;
    (Utils.instance = this),
      (this.settings = { dev: !0, hideClass: "hide", defaultBgColor: "#000" }),
      this.extendEventTargetPrototype(),
      document.addEventListener("DOMContentLoaded", () => {
        this.cacheDomElements(), this.init();
      });
  }
  cacheDomElements() {
    (this.settings.header = document.querySelector(".header")),
      (this.settings.headerWrapper = document.querySelector(".header-wrapper"));
  }
  init() {
    this.initSmoothScroll(),
      this.initTooltips(),
      this.initDomSizeEqualizer(),
      this.initFeatureScripts(),
      this.initResizeObserver(),
      this.setOddLastGridItem(),
      this.settings.dev && this.initImageSizeLogging();
  }
  initFeatureScripts() {
    this.initStickyButtonHandler(),
      this.initProductCardVariantHandler(),
      this.initProductCardButtonHandler(),
      document.delegateListener("click", "[data-filter]", function () {
        const t = this.dataset.filter,
          e = this.closest("section");
        e
          .querySelectorAll("[data-filter]")
          .forEach((t) => t.classList.remove("style--selected")),
          this.classList.add("style--selected"),
          e.querySelectorAll("[data-group]").forEach((e) => {
            "All" !== t
              ? e.dataset.group === t
                ? e.classList.remove("hide")
                : (e.classList.add("hide"), e.close && e.close())
              : e.classList.remove("hide");
          });
      });
  }
  debounce(t, e = 100) {
    let s;
    return (...i) => {
      clearTimeout(s), (s = setTimeout(() => t.apply(this, i), e));
    };
  }
  initResizeObserver() {
    const t = document.documentElement,
      e = () => {
        const e = {
          "--announcement-height": document.querySelector(
            ".announcement-bar-section",
          ),
          "--header-height": document.querySelector(".section-header"),
          "--headerGroup-height": document.querySelector(".header-group"),
          "--headerQuiz-height": document.querySelector(".element-header"),
          "--footer-height": document.querySelector(".footer"),
        };
        Object.entries(e).forEach(([e, s]) => {
          s && t.style.setProperty(e, `${s.clientHeight}px`);
        }),
          t.style.setProperty("--app-height", `${window.innerHeight}px`);
      },
      s = this.debounce(e, 100);
    new ResizeObserver(s).observe(document.body), e();
  }
  initLazyBackgrounds() {
    const t = document.querySelectorAll(".style--backgroundLazy"),
      e = new IntersectionObserver((t) => {
        t.forEach((t) => {
          if (t.isIntersecting) {
            const s = t.target,
              i = s.dataset.style;
            i &&
              ((s.style.cssText += i),
              s.classList.remove("style--backgroundLazy"),
              e.unobserve(s));
          }
        });
      });
    t.forEach((t) => e.observe(t));
  }
  initProductCardVariantHandler() {
    const t = {};
    document.delegateListener("click", "button[data-url]", async function () {
      const e = this,
        s = e.dataset.url,
        i = e.closest(".grid__item") || e.closest(".slide--inner"),
        n = i;
      if (
        (i
          .querySelectorAll("button[data-url]")
          .forEach((t) => t.classList.remove("style--selected")),
        e.classList.add("style--selected"),
        t[s])
      )
        n.innerHTML = t[s];
      else
        try {
          const e = await fetch(s);
          if (!e.ok) throw new Error("Network response was not ok");
          const i = await e.text();
          (t[s] = i), (n.innerHTML = i);
        } catch (t) {
          console.error("Variant fetch failed:", t);
        }
    });
  }
  initProductCardButtonHandler() {
    document.delegateListener(
      "click",
      "button.element-button",
      async function () {
        const t = this,
          e = t.dataset.id;
        if (e) {
          t.classList.add("style--buttonLoading");
          try {
            if (
              !(
                await fetch("/cart/add.js", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                  },
                  body: JSON.stringify({ id: e, quantity: 1 }),
                })
              ).ok
            )
              throw new Error("Failed to add to cart");
            const t = await fetch("/cart.js"),
              s = await t.json();
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "custom-button",
              cartData: s,
              variantId: e,
            });
          } catch (t) {
            console.error("Add to cart failed:", t);
          } finally {
            t.classList.remove("style--buttonLoading");
          }
        }
      },
    );
  }
  initDataTriggerHandler() {
    document.body.addEventListener("click", (t) => {
      const e = t.target.closest("[data-trigger]");
      if (e) {
        const t = document.querySelector(e.getAttribute("data-trigger"));
        t?.click();
      }
    });
  }
  initSmoothScroll() {
    document.body.addEventListener("click", (t) => {
      const e = t.target.closest("[data-scroll]");
      if (e && e.getAttribute("href")) {
        t.preventDefault();
        const s = document.querySelector(e.getAttribute("href"));
        s?.scrollIntoView({ behavior: "smooth" });
      }
    });
  }
  initTooltips() {
    document.body.addEventListener("mouseover", (t) => {
      const e = t.target.closest("[data-snippet='tooltip']");
      e?.setAttribute("data-active", "true");
    }),
      document.body.addEventListener("mouseout", (t) => {
        const e = t.target.closest("[data-snippet='tooltip']");
        e && !e.contains(t.relatedTarget) && e.removeAttribute("data-active");
      });
  }
  formatMoney(t) {
    const e = Number(Shopify.currency.rate);
    return window.utils.moneyFormat.replace(
      /\{.*\}/g,
      ((t * e) / 100).toFixed(2),
    );
  }
  initDomSizeEqualizer() {
    (this._equalizeMap = new WeakMap()),
      document.querySelectorAll("section").forEach((t) => {
        const e = this.debounce(() => {
          this.equalizeSize(t);
        }, 100);
        this._equalizeMap.set(t, e);
        new ResizeObserver(() => {
          const e = this._equalizeMap.get(t);
          e && e();
        }).observe(t),
          this.equalizeSize(t);
      });
  }
  equalizeSize(t) {
    if (!t) return;
    const e = t.querySelectorAll('[data-height="equal"]'),
      s = t.querySelectorAll('[data-height="min"]'),
      i = t.querySelectorAll('[data-width="min"]');
    e.forEach((t) => (t.style.height = "auto")),
      s.forEach((t) => (t.style.height = "auto")),
      i.forEach((t) => (t.style.width = "auto")),
      t.style.removeProperty("--equal-height"),
      t.style.removeProperty("--min-height"),
      t.style.removeProperty("--min-width"),
      requestAnimationFrame(() => {
        let n = 0,
          o = 1 / 0,
          r = 1 / 0;
        e.forEach((t) => {
          n = Math.max(n, t.offsetHeight);
        }),
          s.forEach((t) => {
            o = Math.min(o, t.offsetHeight);
          }),
          i.forEach((t) => {
            r = Math.min(r, t.offsetWidth);
          }),
          n > 20 && t.style.setProperty("--equal-height", `${n}px`),
          o > 20 &&
            o !== 1 / 0 &&
            t.style.setProperty("--min-height", `${o}px`),
          r > 20 && r !== 1 / 0 && t.style.setProperty("--min-width", `${r}px`);
      });
  }
  setHeightVariable(t) {
    const e = t.querySelector('[data-height="set"]');
    e &&
      e.offsetHeight > 20 &&
      t.style.setProperty("--element-height", `${e.offsetHeight}px`);
    const s = t.querySelector('[data-width="set"]');
    s &&
      s.offsetWidth > 20 &&
      t.style.setProperty("--element-width", `${s.offsetWidth}px`);
  }
  extendEventTargetPrototype() {
    EventTarget.prototype.delegateListener ||
      (EventTarget.prototype.delegateListener = function (t, e, s) {
        this.addEventListener(t, function (t) {
          const i = t.target.closest(e);
          i && this.contains(i) && s.call(i, t);
        });
      });
  }
  initStickyButtonHandler() {
    const t = document.querySelector(".sticky--button .button--primary");
    t?.addEventListener("click", () => {
      const t = document.querySelector('[type="submit"].product-form__submit');
      t?.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }
  initImageSizeLogging() {
    const t = getComputedStyle(document.documentElement)
        .getPropertyValue("--breakpoints")
        .replaceAll("px", "")
        .split(", ")
        .map((t) => t.trim())
        .map(Number),
      e = new Map();
    let s = null;
    console.log("Breakpoints: ", t);
    const i = () => {
      if (e.size === t.length) {
        const s = t.map((t) => e.get(t)),
          i = Math.min(...s),
          n = Math.max(...s),
          o = s.map((t) => t.toFixed(2)).join(", ");
        console.log(`${o}, ${i.toFixed(0)}:${n.toFixed(0)}`);
      }
    };
    window.addEventListener("resize", () => {
      const n = Math.floor(window.innerWidth);
      if (t.includes(n) && n !== s)
        if (((s = n), window.temp1 instanceof HTMLElement)) {
          const t = window.temp1.clientWidth;
          e.set(n, t),
            console.log(
              `\n[Viewport ${n}px] temp1 rendered size: ${t.toFixed(2)}`,
            ),
            i();
        } else
          console.log(
            `\n[Viewport ${n}px] temp1 is not set or not an element.`,
          );
    });
    const n = Math.floor(window.innerWidth);
    if (t.includes(n) && window.temp1 instanceof HTMLElement) {
      const t = window.temp1.clientWidth;
      e.set(n, t),
        console.log(`\n[Viewport ${n}px] temp1 rendered size: ${t.toFixed(2)}`),
        i();
    }
  }
  setOddLastGridItem(t) {
    document.querySelectorAll(".grid--wrapper").forEach((t) => {
      const e = Array.from(t.children);
      if (!e.length) return;
      e.forEach((t) => {
        t.classList.remove("style--smFull", "style--mdFull", "style--lgFull"),
          t.style.removeProperty("--grid-span-sm"),
          t.style.removeProperty("--grid-span-md"),
          t.style.removeProperty("--grid-span-lg");
      });
      const s = t.className,
        i = s.match(/style--lg(\d+)/),
        n = s.match(/style--md(\d+)/),
        o = s.match(/style--sm(\d+)/),
        r = e[e.length - 1];
      if (i && e.length % parseInt(i[1], 10) > 0) {
        const t = parseInt(i[1], 10);
        r.classList.add("style--lgFull"),
          r.style.setProperty("--grid-span-lg", t);
      }
      if (n && e.length % parseInt(n[1], 10) > 0) {
        const t = e.length % parseInt(n[1], 10);
        r.classList.add("style--mdFull"),
          r.style.setProperty("--grid-span-md", t);
      }
      if (o && e.length % parseInt(o[1], 10) > 0) {
        const t = parseInt(o[1], 10);
        r.classList.add("style--smFull"),
          r.style.setProperty("--grid-span-sm", t);
      }
    });
  }
}
new Utils();
class DropdownElement extends HTMLElement {
  connectedCallback() {
    this.init();
  }
  init() {
    Element.prototype.on ||
      ((Element.prototype.on = function (t, e, s = !1) {
        return (
          this._eventNamespaces || (this._eventNamespaces = {}),
          (this._eventNamespaces[t] = e),
          this.addEventListener(t.split(".")[0], e, s),
          this
        );
      }),
      (Element.prototype.off = function (t) {
        if (!this._eventNamespaces) return;
        const e = this._eventNamespaces[t];
        return (
          e &&
            (this.removeEventListener(t.split(".")[0], e),
            delete this._eventNamespaces[t]),
          this
        );
      })),
      (this.isTransitioning = !1),
      this.cleanupText(),
      this.initializeDropdown();
  }
  cleanupText() {
    this.querySelectorAll(".dropdown--inner p").forEach((t) => {
      t.childNodes.forEach((t) => {
        t.nodeType === Node.TEXT_NODE &&
          (t.textContent = t.textContent.replace(/\s+/g, " "));
      });
    }),
      "" === this.querySelector(".dropdown--inner").textContent.trim() &&
        this.classList.add("hide");
  }
  initializeDropdown() {
    const t = {
        trigger: '[data-dropwdown="trigger"]',
        body: '[data-dropwdown="body"]',
        inner: ".dropdown--inner",
      },
      e = { open: "is-open", transitioning: "is-transitioning" };
    this.querySelectorAll(t.trigger).forEach((s) => {
      const i = s.classList.contains(e.open);
      s.setAttribute("aria-expanded", i),
        s.off("click.dropdown"),
        s.on("click.dropdown", (s) => this.toggleDropdown(s, t, e));
    });
  }
  toggleDropdown(t, e, s) {
    if (this.isTransitioning) return;
    this.isTransitioning = !0;
    const i = t.currentTarget,
      n = i.classList.contains(s.open),
      o = i.getAttribute("aria-controls"),
      r = this.querySelector(`#${o}`);
    if (!r) return void (this.isTransitioning = !1);
    const a = r.querySelector(e.inner).offsetHeight;
    n
      ? ((r.style.height = `${a}px`),
        requestAnimationFrame(() => {
          r.style.height = "0";
        }))
      : ((r.style.height = "0"),
        requestAnimationFrame(() => {
          r.style.height = `${a}px`;
        })),
      r.addEventListener(
        "transitionend",
        () => {
          (r.style.height = n ? "0" : "auto"),
            r.classList.toggle(s.open, !n),
            i.classList.toggle(s.open, !n),
            i.setAttribute("aria-expanded", !n),
            (this.isTransitioning = !1);
        },
        { once: !0 },
      );
  }
  close(t = null) {
    const e = '[data-dropwdown="trigger"]',
      s = ".dropdown--inner",
      i = "is-open";
    if (this.isTransitioning) return;
    (t ? [t] : Array.from(this.querySelectorAll(e))).forEach((t) => {
      if (!t.classList.contains(i)) return;
      const e = t.getAttribute("aria-controls"),
        n = this.querySelector(`#${e}`);
      if (!n) return;
      this.isTransitioning = !0;
      const o = n.querySelector(s).offsetHeight;
      (n.style.height = `${o}px`),
        requestAnimationFrame(() => {
          n.style.height = "0";
        }),
        n.addEventListener(
          "transitionend",
          () => {
            (n.style.height = "0"),
              n.classList.remove(i),
              t.classList.remove(i),
              t.setAttribute("aria-expanded", "false"),
              (this.isTransitioning = !1);
          },
          { once: !0 },
        );
    });
  }
}
customElements.define("dropdown-element", DropdownElement);
class SliderElement extends HTMLElement {
  async connectedCallback() {
    const t = this.getAttribute("data-settings"),
      e = t ? JSON.parse(t) : {},
      s = [],
      i = [];
    let n = this.querySelector(".swiper");
    const o = this.closest(".slider--wrapper") || this.closest("section"),
      r = o?.querySelectorAll(".text--wrapper [data-index][data-hide]"),
      a = this.classList.contains("js--progress")
        ? ".swiper-pagination.style--progressbar"
        : ".swiper-pagination.style--progressbar:not(.js--ignore)",
      l = o?.querySelector(a) || null,
      c = this.classList.contains("js--pagination")
        ? ".swiper-pagination"
        : ".swiper-pagination:not(.js--ignore)",
      d = o?.querySelector(c) || null,
      h = this.classList.contains("js--scrollbar")
        ? ".swiper-scrollbar"
        : ".swiper-scrollbar:not(.js--ignore)",
      u = o?.querySelector(h) || null,
      p = o?.querySelector(".swiper-button-next:not(.style--secondary)"),
      g = o?.querySelector(".swiper-button-prev:not(.style--secondary)"),
      m = o?.querySelector(".swiper-button-next.style--secondary"),
      y = o?.querySelector(".swiper-button-prev.style--secondary");
    p && g && (s.push(p), i.push(g)), m && y && (s.push(m), i.push(y));
    const f = {
      loop: !1,
      centerInsufficientSlides: !0,
      spaceBetween: 10,
      autoplay: !1,
      navigation: { nextEl: s, prevEl: i },
    };
    l
      ? (f.pagination = { el: l, type: "progressbar" })
      : d && (f.pagination = { el: d, clickable: !0 });
    (o?.querySelector(".swiper-counter") || r?.length) &&
      (f.on = {
        ...f.on,
        slideChangeTransitionEnd(t) {
          ((t) => {
            const e = o?.querySelector(".swiper-counter");
            if (!e) return;
            const s = t.slides.length,
              i = t.realIndex + 1;
            e.innerHTML = `${i.toString().padStart(2, "0")} / <span>${s.toString().padStart(2, "0")}</span>`;
          })(t),
            ((t) => {
              if (!r || !r.length) return;
              const e = t.realIndex + 1;
              r.forEach((t) => {
                const s = Number(t.dataset.index);
                t.setAttribute("data-hide", s === e ? "false" : "true");
              });
            })(t);
        },
      }),
      e.thumbs && (e.thumbs.swiper = o.querySelector(".slider-thumbs .swiper")),
      u && (f.scrollbar = { el: u }),
      this.classList.contains(".main-gallery");
    const b = { ...f, ...e },
      S = this.getAttribute("data-content");
    if ("" !== S) {
      if (S) {
        this.querySelector(".swiper-wrapper").classList.add(
          "style--sectionLoading",
        );
        const t = `/search?q=${S.split(",")
          .map((t) => `"${t}"`)
          .join("+OR+")}&view=slider`;
        try {
          const e = await fetch(t);
          if (e.ok) {
            const t = await e.text();
            (n.querySelector(".swiper-wrapper").innerHTML = t),
              (n = this.querySelector(".swiper")),
              n
                ? new Swiper(n, b)
                : console.error(
                    "Swiper container not found after content update.",
                  );
          } else console.error("Failed to fetch slider content:", e.status);
        } catch (t) {
          console.error("Error fetching slider content:", t);
        }
      } else n && new Swiper(n, b);
      this.querySelector(".swiper-wrapper").classList.remove(
        "style--sectionLoading",
      );
    } else this.closest("section").classList.add("hide");
  }
}
customElements.define("slider-element", SliderElement);
class UpsellElement extends HTMLElement {
  constructor() {
    super(), (this.upsellProductId = null), (this.upsellProductIds = []);
  }
  connectedCallback() {
    this.updateSelectedUpsell(),
      this.addEventListeners(),
      this.checkAndFixCart();
  }
  addEventListeners() {
    this.querySelectorAll("input[type='radio']").forEach((t) => {
      t.addEventListener("change", () => this.handleSelectionChange());
    }),
      document.addEventListener("upsell:update", (t) => {
        this.checkAndFixCart(t.detail);
      });
  }
  updateSelectedUpsell() {
    let t = this.querySelector("input[type='radio']:checked");
    (this.upsellProductId = t ? t.value : null),
      (this.upsellProductIds = Array.from(
        this.querySelectorAll("input[type='radio']"),
      ).map((t) => t.value));
  }
  async fetchCart() {
    try {
      let t = await fetch("/cart.js");
      return await t.json();
    } catch (t) {
      return console.error("UpsellElement: Error fetching cart:", t), null;
    }
  }
  async checkAndFixCart(t = null) {
    let e = t || (await this.fetchCart());
    if (!e) return;
    let s = e.items
        .filter((t) => this.upsellProductIds.includes(String(t.id)))
        .map((t) => String(t.id)),
      i = e.items.some((t) => !this.upsellProductIds.includes(String(t.id))),
      n = {};
    s.length > 1 &&
      s.forEach((t) => {
        t !== this.upsellProductId && (n[t] = 0);
      }),
      i &&
        !s.includes(this.upsellProductId) &&
        this.upsellProductId &&
        (n[this.upsellProductId] = 1),
      !i && s.length > 0 && s.forEach((t) => (n[t] = 0)),
      Object.keys(n).length > 0 &&
        this.modifyCart({ updates: n, sections: this.getSectionSelectors() });
  }
  handleSelectionChange() {
    let t = this.upsellProductId;
    this.updateSelectedUpsell();
    let e = {};
    t && t !== this.upsellProductId && (e[t] = 0),
      this.upsellProductId && (e[this.upsellProductId] = 1),
      Object.keys(e).length > 0 &&
        this.modifyCart({ updates: e, sections: this.getSectionSelectors() });
  }
  modifyCart(t) {
    document
      .querySelector(".cart-main")
      ?.classList.add("style--sectionLoading"),
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(t),
      })
        .then((t) => t.json())
        .then((t) => {
          publish("cartPage-update", {
            source: "cart-items",
            cartData: t,
            variantId: this.upsellProductId,
          });
        })
        .catch((t) => console.error("UpsellElement: Error updating cart:", t));
  }
  getSectionSelectors() {
    return [
      document.getElementById("main-cart-footer")?.dataset.id,
      "cart-icon-bubble",
      "cart-live-region-text",
      document.getElementById("main-cart-items")?.dataset.id,
    ].filter(Boolean);
  }
}
customElements.define("upsell-element", UpsellElement);
class DynamicProducts extends HTMLElement {
  constructor() {
    super(),
      (this.debounceTimer = null),
      (this.cache = new Map()),
      (this.type = "sku"),
      (this.debouncedLoadContent = debounce(this.loadContent.bind(this), 200));
  }
  connectedCallback() {
    (this.ids = this.getAttribute("data-content")),
      (this.container = this.querySelector(".container")),
      this.loadContent();
  }
  async loadContent() {
    if (!this.container || !this.ids) return void console.error("Missing Data");
    if (this.cache.has(this.ids))
      return void (this.container.innerHTML = this.cache.get(this.ids));
    const t = `/search?q=${this.ids
      .split(",")
      .map((t) => encodeURIComponent(`"${t.trim()}"`))
      .join("+OR+")}&view=dynamic`;
    try {
      const e = await fetch(t);
      if (e.ok) {
        const t = await e.text();
        this.cache.set(this.ids, t), (this.container.innerHTML = t);
      } else console.error("Failed to fetch slider content:", e.status);
    } catch (t) {
      console.error("Error fetching slider content:", t);
    }
  }
  static get observedAttributes() {
    return ["data-content"];
  }
  attributeChangedCallback(t, e, s) {
    "data-content" === t &&
      e !== s &&
      ((this.ids = s), this.debouncedLoadContent());
  }
  refresh() {
    this.debouncedLoadContent();
  }
  disconnectedCallback() {
    clearTimeout(this.debounceTimer);
  }
}
customElements.define("dynamic-products", DynamicProducts);
class PopupElement extends HTMLElement {
  constructor() {
    super(),
      (this.togglePopup = this.togglePopup.bind(this)),
      (this.closePopup = this.closePopup.bind(this)),
      (this.handleKeydown = this.handleKeydown.bind(this));
  }
  connectedCallback() {
    (this.button = this.querySelector('button[type="button"]')),
      (this.popup = this.querySelector(".popup")),
      (this.inner = this.querySelector(".popup--inner")),
      (this.closeBtn = this.querySelector('[data-controls="close"]')),
      this.button &&
        this.popup &&
        this.button.addEventListener("click", this.togglePopup),
      this.closeBtn && this.closeBtn.addEventListener("click", this.closePopup),
      document.addEventListener("keydown", this.handleKeydown);
  }
  togglePopup() {
    this.popup.classList.contains("visible")
      ? this.closePopup()
      : (this.popup.classList.add("visible"),
        this.popup.setAttribute("aria-hidden", "false"),
        this.inner.focus());
  }
  closePopup() {
    this.popup.classList.remove("visible"),
      this.popup.setAttribute("aria-hidden", "true"),
      this.button.focus();
  }
  handleOutsideClick(t) {
    this.contains(t.target) || this.closePopup();
  }
  handleKeydown(t) {
    if (
      this.popup.classList.contains("visible") &&
      ("Escape" === t.key && this.closePopup(), "Tab" === t.key)
    ) {
      const e = this.popup.querySelectorAll(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
        ),
        s = e[0],
        i = e[e.length - 1];
      t.shiftKey && document.activeElement === s
        ? (t.preventDefault(), i.focus())
        : t.shiftKey ||
          document.activeElement !== i ||
          (t.preventDefault(), s.focus());
    }
  }
  disconnectedCallback() {
    document.removeEventListener("click", this.handleOutsideClick),
      document.removeEventListener("keydown", this.handleKeydown);
  }
}
customElements.define("popup-element", PopupElement);
class SelectElement extends HTMLElement {
  constructor() {
    super(),
      (this.select = null),
      (this.input = null),
      (this.button = null),
      (this.dropdownContainer = null),
      (this.isOpen = !1);
  }
  connectedCallback() {
    (this.select = this.querySelector("select")),
      (this.input = this.querySelector(".search-input")),
      (this.button = this.querySelector("[data-trigger]")),
      (this.dropdownContainer = this.querySelector(".select-drpdown--inner")),
      this.renderDropdown(),
      this.attachEventListeners(),
      this.highlightSelected();
  }
  attachEventListeners() {
    if (!this.select) return;
    this.select.addEventListener("change", () => this.highlightSelected()),
      this.input &&
        (this.input.addEventListener("focus", () => this.open()),
        this.input.addEventListener("blur", () => {
          setTimeout(() => this.close(), 200);
        }),
        this.input.addEventListener("input", () => this.filterOptions())),
      this.button &&
        this.button.addEventListener("click", () => {
          this.isOpen ? this.close() : this.open();
        }),
      document.addEventListener("click", (t) => {
        this.contains(t.target) || this.close();
      });
    new MutationObserver(() => this.renderDropdown()).observe(this.select, {
      childList: !0,
      subtree: !0,
    });
  }
  open() {
    (this.isOpen = !0), this.showDropdown(!0), this.toggleActiveClass(!0);
  }
  close() {
    (this.isOpen = !1), this.showDropdown(!1), this.toggleActiveClass(!1);
  }
  toggleActiveClass(t) {
    const e = this.querySelector(".select--inner");
    e && e.classList.toggle("active", t);
  }
  renderDropdown() {
    if (!this.dropdownContainer || !this.select) return;
    const t = Array.from(this.select.options);
    (this.dropdownContainer.innerHTML = ""),
      t.forEach((t) => {
        const e = document.createElement("div");
        (e.className = "dropdown-item"),
          (e.innerHTML = `<span data-value="${t.value}">${t.textContent}</span>`),
          e.addEventListener("click", () => {
            (this.select.value = t.value),
              this.select.dispatchEvent(new Event("input", { bubbles: !0 })),
              this.close();
          }),
          this.dropdownContainer.appendChild(e);
      }),
      this.highlightSelected();
  }
  showDropdown(t) {
    const e = this.querySelector(".select-drpdown--inner");
    e && (e.style.display = t ? "block" : "none");
  }
  highlightSelected() {
    if (!this.select) return;
    const t = this.select.value;
    this.dropdownContainer
      .querySelectorAll(".dropdown-item span")
      .forEach((e) => {
        e.parentElement.classList.toggle("selected", e.dataset.value === t);
      });
    const e = this.select.selectedOptions[0]?.textContent || "";
    this.input && (this.input.value = e),
      this.button &&
        (this.button.querySelector("[data-current]").textContent =
          e || "Sort By");
  }
  filterOptions() {
    if (!this.input) return;
    const t = this.input.value.toLowerCase();
    this.dropdownContainer.querySelectorAll(".dropdown-item").forEach((e) => {
      const s = e.textContent.toLowerCase();
      e.style.display = s.includes(t) ? "" : "none";
    });
  }
}
customElements.define("select-element", SelectElement);
class DynamicGrid extends HTMLElement {
  constructor() {
    super(),
      (this.totalCount = parseInt(this.getAttribute("data-total"))),
      (this.currentCount = parseInt(this.getAttribute("data-current"))),
      (this.page = 1),
      (this.cache = new Map()),
      (this.CACHE_VERSION = "v2"),
      (this.TTL = 18e5),
      (this.MAX_ENTRIES = 15);
  }
  connectedCallback() {
    (this.baseUrl = this.getAttribute("data-source")),
      (this.container = this.querySelector("[data-container]")),
      (this.loadButton = this.querySelector("[data-load]")),
      (this.storageKey = `dynamic-grid-cache:${this.baseUrl}`),
      this.loadButton &&
        this.loadButton.addEventListener("click", () => {
          this.page++, this.loadContent();
        }),
      this.closest("section").addEventListener("click", (t) => {
        const e = t.target.closest("button[data-filter]");
        e &&
          ((this.currentCount = parseInt(e.getAttribute("data-current")) || 3),
          (this.totalCount = parseInt(e.getAttribute("data-total"))),
          (this.baseUrl = e.getAttribute("data-source")),
          (this.page = 1),
          (this.container.innerHTML =
            '<div style="order: 99;" class="grid-item hide"></div>'),
          this.loadContent(),
          this.closest("section")
            .querySelectorAll("button[data-filter]")
            .forEach((t) => {
              t.classList.toggle("style--selected", t === e);
            }));
      });
  }
  getStorage() {
    const t = localStorage.getItem(this.storageKey);
    if (!t) return this.createEmptyStorage();
    try {
      const e = JSON.parse(t);
      return e.version && e.version === this.CACHE_VERSION
        ? e
        : (localStorage.removeItem(this.storageKey), this.createEmptyStorage());
    } catch {
      return (
        localStorage.removeItem(this.storageKey), this.createEmptyStorage()
      );
    }
  }
  setStorage(t) {
    localStorage.setItem(this.storageKey, JSON.stringify(t));
  }
  createEmptyStorage() {
    return { version: this.CACHE_VERSION, entries: {} };
  }
  getValidCachedEntry(t, e) {
    const s = t.entries[e];
    return s
      ? Date.now() - s.timestamp > this.TTL
        ? (delete t.entries[e], this.setStorage(t), null)
        : s.html
      : null;
  }
  pruneOldEntries(t) {
    const e = Object.keys(t.entries);
    if (e.length <= this.MAX_ENTRIES) return;
    e
      .sort((e, s) => t.entries[e].timestamp - t.entries[s].timestamp)
      .slice(0, e.length - this.MAX_ENTRIES)
      .forEach((e) => {
        delete t.entries[e];
      }),
      this.setStorage(t);
  }
  updateMetaContent() {
    (this.currentCount = this.querySelectorAll(
      "[data-container] > div:not(.hide)",
    ).length),
      (this.querySelector("[data-count]").textContent = this.currentCount),
      (this.querySelector("[data-total]").textContent = this.totalCount),
      this.style.setProperty(
        "--progress",
        (this.currentCount / this.totalCount) * 100 + "%",
      ),
      this.querySelector("[data-load]").setAttribute(
        "data-hide",
        this.currentCount >= this.totalCount,
      ),
      this.container.classList.toggle("style--sectionLoading", !1);
  }
  async loadContent() {
    if (!this.container || !this.baseUrl) return;
    this.container.classList.toggle("style--sectionLoading", !0);
    const t = `${this.baseUrl}&page=${this.page}`;
    if (this.cache.has(t))
      return (
        this.container.insertAdjacentHTML("beforeend", this.cache.get(t)),
        void this.updateMetaContent()
      );
    const e = this.getStorage(),
      s = this.getValidCachedEntry(e, t);
    if (s)
      return (
        this.cache.set(t, s),
        this.container.insertAdjacentHTML("beforeend", s),
        void this.updateMetaContent()
      );
    try {
      const s = await fetch(t);
      if (!s.ok) throw new Error("Fetch failed");
      const i = await s.text(),
        n = new DOMParser().parseFromString(i, "text/html"),
        o = n.querySelector("[data-container]")?.innerHTML;
      if (!o) return void (this.loadButton && this.loadButton.remove());
      this.cache.set(t, o),
        (e.entries[t] = { html: o, timestamp: Date.now() }),
        this.pruneOldEntries(e),
        this.setStorage(e),
        this.container.insertAdjacentHTML("beforeend", o),
        this.updateMetaContent();
    } catch (t) {
      console.error("DynamicGrid load error:", t);
    }
  }
}
customElements.define("dynamic-grid", DynamicGrid);
